import React from "react";

import DooStyleRadioGroup from "./DooStyleRadioGroup";
import { cn } from "../../../../lib/utils";

const DoorStyle = ({ methods, isOpen: { DoorStyle } }) => {
    return (
        <div
            className={cn(
                "section grid grid-cols-4 overflow-hidden transition-all h-0 opacity-0 !py-8",
                {
                    ["h-full opacity-100"]: DoorStyle.isOpen,
                }
            )}
        >
            <DooStyleRadioGroup {...methods} />
        </div>
    );
};

export default DoorStyle;
